export default __webpack_public_path__ + "static/media/Umbrella.df170598.png";